<div class="wrapper">
	<!-- <ng-container *ngIf="!customView"> -->
	<div
		class="wrapper-articles"
		#wrapperArticles
		[class.show-list]="showFirstArticles || !showAllButton"
		(scroll)="onScroll()"
		tabindex="0"
		role="listbox"
		[attr.aria-multiselectable]="optionGroupValue.hasMultiple ? 'true' : 'false'"
		[attr.aria-label]="optionGroupValue.description || 'Available options'"
	>
		<!-- Back scroll button with keyboard accessibility -->
		<button class="back-icon nav-button" (click)="scrollBack()" *ngIf="showBackIcon" aria-label="Scroll to previous items" tabindex="0">
			<ion-icon name="arrow-back-outline" aria-hidden="true"></ion-icon>
			<span class="visually-hidden">Previous items</span>
		</button>
		<ng-container *ngFor="let optionArticle of optionGroupValue.articles; let i = index">
			<div *ngIf="!isHidden(optionArticle)" class="item" role="option">
				<!-- Selectable item component -->
				<app-item-selectable-article-custom
					(add)="onAdd(optionArticle)"
					(remove)="onRemove(optionArticle)"
					[mainArticle]="article"
					[article]="optionArticle"
					[currency]="currency"
					[group]="optionGroupValue"
					[preorderType]="preorderType"
					[selected]="count(optionArticle)"
					[customAdd]="checkIfModifierSelectExist(optionGroupValue)"
					[customRemove]="checkIfModifierRemoveExist(optionGroupValue)"
					class="pointer"
				></app-item-selectable-article-custom>
			</div>
		</ng-container>

		<!-- Forward scroll button with keyboard accessibility -->
		<button
			class="next-icon nav-button"
			(click)="scrollForward()"
			(keydown.enter)="scrollForward()"
			(keydown.space)="scrollForward()"
			*ngIf="showNextIcon"
			aria-label="Scroll to next items"
			tabindex="0"
		>
			<ion-icon name="arrow-forward-outline" aria-hidden="true"></ion-icon>
			<span class="visually-hidden">Next items</span>
		</button>
	</div>
</div>
